import { render, staticRenderFns } from "./KZGComponentList.vue?vue&type=template&id=033a5cd2&scoped=true"
import script from "./KZGComponentList.vue?vue&type=script&lang=js"
export * from "./KZGComponentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a5cd2",
  null
  
)

export default component.exports